import {
  CAPACITY_EXCEEDED_ERROR_MESSAGE,
  TIMEKIT_BOOKING_ERROR_MESSAGE,
  VisitorRegistrationErrorsEnum,
} from 'shared/consts/errors';
import { PaymentErrorsEnum } from 'shared/consts/payment-error-types';
import { BookingCreationError } from 'store/booking-flow/types';

export const isCapacityExceededError = (cartError?: SerializableError): boolean =>
  cartError?.message?.includes(CAPACITY_EXCEEDED_ERROR_MESSAGE) ?? false;

export const getCartErrorMessage = (cartError: SerializableError): BookingCreationError => {
  if (cartError?.message.includes(TIMEKIT_BOOKING_ERROR_MESSAGE)) {
    return BookingCreationError.BOOKING_PROBLEM_APOINTMENT;
  }

  // A booking can also create visitors, and visitor registration reports failures differently from
  // payments: a plain-string `message` plus a separate top-level `errorCode`. Nothing lands on
  // `key`, so these used to fall through to the generic CART_SUBMISSION copy. See RES-1011.
  if (cartError?.response?.errorCode === VisitorRegistrationErrorsEnum.DUPLICATE_PROFILE) {
    return BookingCreationError.DUPLICATE_VISITOR_PROFILE;
  }

  // Not a payment problem: too many people for the resource. See RES-1423.
  if (isCapacityExceededError(cartError)) {
    return BookingCreationError.CAPACITY_EXCEEDED;
  }

  switch (cartError?.key) {
    case PaymentErrorsEnum.BOOKING_UNAVAILABLE_ERROR:
      return BookingCreationError.BOOKING_UNAVAILABLE;
    case PaymentErrorsEnum.CARD_DECLINED_ERROR:
      return BookingCreationError.CARD_DECLINED;
    case PaymentErrorsEnum.CART_SUBMISSION_ERROR:
      return BookingCreationError.CART_SUBMISSION;
    case PaymentErrorsEnum.PAYMENT_PROCESSING_ERROR:
      return BookingCreationError.PAYMENT_PROCESSING;
    default:
      return BookingCreationError.CART_SUBMISSION;
  }
};
